import React from 'react';
import ReactDOM from 'react-dom';
import {
    HashRouter,
    Route,
    Switch
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import mainReducer from './containers/App/Reducers/mainReducer';

import indexRoutes from './routes/index.jsx';

import registerServiceWorker from './registerServiceWorker';

import './assets/css/bootstrap.min.css';
import './assets/sass/light-bootstrap-dashboard.css';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';

export const store = createStore(
  mainReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render((
  <Provider store={store}>
    <HashRouter>
      <Switch>
        {
          indexRoutes.map((prop,key) => {
            return (
              <Route path={prop.path} component={prop.component}  key={key}/>
            );
          })
        }
      </Switch>
    </HashRouter>
  </Provider>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js